module.exports = __webpack_public_path__ + "static/media/ico-phone.1c25c2a1.svg";